module.exports = __webpack_public_path__ + "img/success.a41b9ba0.png";